import merge from "deepmerge";
import axios from "axios";
import {apiEndpoint} from "../Constants/api";
import moment from "moment";

//Constants:

const GET_LIST = "GET_LIST";
const GET_ONE = "GET_ONE";
const GET_MANY = "GET_MANY";
const GET_MANY_REFERENCE = "GET_MANY_REFERENCE";
const CREATE = "CREATE";
const UPDATE = "UPDATE";
const DELETE = "DELETE";

interface queryObject {
    [key: string]: any
}

interface optionsObject {
    [key: string]: any
}

//Default settings:
const defaultSettings = {
    total: "total",
    headers: {
        "Content-Type": "application/json",
        accept: "*/*"
    },
    updateMethod: "PATCH",
    arrayFormat: "brackets",
};

// Handle HTTP errors.
const init = () => {
    // Request interceptor
    axios.interceptors.request.use(
        (config) => {
            const token = localStorage.getItem("token");
            const username = localStorage.getItem("username");
            const password = localStorage.getItem("password");

            const newConfig = config;

            // When a 'token' is available set as Bearer token.
            if (token) {
                newConfig.headers.Authorization = `Bearer ${token}`;
            }

            // When username and password are available use
            // as basic auth credentials.
            if (username && password) {
                newConfig.auth = {username, password};
            }

            return newConfig;
        },
        err => Promise.reject(err),
    );

    // Response interceptor
    axios.interceptors.response.use(
        response => response,
        (error) => {
            const {status, data} = error.response;

            if (status < 200 || status >= 300) {
                return Promise.reject(error);
            }

            return Promise.reject(error);
        },
    );
};

// Set HTTP interceptors.
init();

// /**
//  * Maps react-admin queries to a JSONAPI REST API
//  *
//  * @param {string} apiEndpoint the base URL for the JSONAPI
//  * @param {Object} userSettings Settings to configure this client.
//  *
//  * @param {string} type Request type, e.g GET_LIST
//  * @param {string} resource Resource name, e.g. "posts"
//  * @param {Object} payload Request parameters. Depends on the request type
//  * @returns {Promise} the Promise for a data response
//  **/
export default (userSettings = {}) => (type, resource, params) => {
    let url = "";
    let idxs;
    let filterKeys;
    let sortField;
    let sortOrder;
    let page;
    let perPage;
    let pageStart;
    let pageFinish;
    if (params.sort && params.sort.order) {
        sortField = params.sort.field;
        sortOrder = params.sort.order;
    }

    if (params.ids) {
        idxs = params.ids;
    }

    if (params.filter) {
        filterKeys = Object.keys(params.filter);
    }

    //create array return for pagination:
    //This is a hacky workaround of waht should be done on theAPI
    if (params.pagination) {
        page = params.pagination.page;
        perPage = params.pagination.perPage;
        pageStart = (page - 1) * perPage;
        pageFinish = pageStart + perPage;
    }
    // console.log(params)
    const settings = merge(defaultSettings, userSettings);

    const token = JSON.parse(localStorage.getItem("auth"))["token"];

    if (token) {
        settings.headers["Authorization"] = `Bearer ${token}`;
    }

    const options: optionsObject = {
        headers: settings.headers,
    };
    switch (type) {
        case GET_LIST:
            let urlMapper = resource === "appointments/search" ?
                `appointments?includeUserDetails=true&status=ACCEPTED&status=REJECTED&status=REQUEST_MADE&offset=0&limit=${pageFinish+1}` : resource;
            if (JSON.stringify(params.filter) !== JSON.stringify({})) {
                const filters = filterKeys.map(key => key === "scheduledDate" ? `startDate=${params.filter[key]}&endDate=${params.filter[key]}` : `${key}=${params.filter[key]}`);
                url = `${apiEndpoint}appointments?${filters.join("&")}${filterKeys.includes("status") ? "&includeUserDetails=true" : "&includeUserDetails=true&status=ACCEPTED&status=REJECTED&status=REQUEST_MADE"}&offset=0&limit=${pageFinish+1}`;
            } else {
                url = `${apiEndpoint}${urlMapper}`;
            }
            break;

        case GET_ONE:
            if (resource.includes("appointments/search")) {
                url = `${apiEndpoint}appointments/${params.id}?includeUserDetails=true`;
            } else {
                url = `${apiEndpoint}${resource}/${params.id}`;
            }
            break;

        case CREATE:
            url = `${apiEndpoint}${resource}`;
            options.method = "POST";
            options.data = JSON.stringify({
                data: {type: resource, attributes: params.data},
            });
            break;

        case UPDATE: {
            console.log("using update");
            // url = `${apiEndpoint}${resource}/${params.id}`;
            let attributes: any;
            let data;
            if (resource.includes("appointments")) {
                // url = `${apiEndpoint}appointments/${params.id}`;
                url = `${apiEndpoint}appointments/${params.id}/behalfOfUser/update?behalfOfUserId=${JSON.parse(window.localStorage.getItem("auth")).userId}`;
                attributes = {
                    type: params.data.type,
                };
                if (moment(params.data.scheduledDate) > moment()) {
                    attributes.scheduledDate = moment(params.data.scheduledDate).utc();
                }
                attributes.finished = params.data.finished;
                data = attributes;
                options.method = "PATCH";
                options.data = JSON.stringify(data);
            } else {
                //url = `${apiEndpoint}${resource}/${params.id}`;
                console.log(`${apiEndpoint}${resource}/${params.id}`);
            }
            // console.log(data)
            break;
        }

        case DELETE:
            url = `${apiEndpoint}${resource}/${params.id}`;
            options.method = "DELETE";
            break;

        case GET_MANY:
            console.log("using GET_MANY");
            if (params.filter) {
                const filters = filterKeys.map(key => key === "scheduledDate" ? `appointmentDate=${params.filter[key]}T00:00:00Z` : `${key}=${params.filter[key]}`);
                url = `${apiEndpoint}${resource}?${filters.join("&")}`;
            } else {
                url = `${apiEndpoint}${resource}`;
            }
            break;

        case GET_MANY_REFERENCE: {
            console.log("using GET_MANY_REFERENCE");
            if (params.filter) {
                const filters = filterKeys.map(key => key === "scheduledDate" ? `appointmentDate=${params.filter[key]}T00:00:00Z` : `${key}=${params.filter[key]}`);
                url = `${apiEndpoint}${resource}?${filters.join("&")}`;
            } else {
                url = `${apiEndpoint}${resource}`;
            }
            break;
        }

        default:
            console.log(`Unsupported Data Provider request type ${type}`);
    }

    return axios({url, ...options})
        .then((response) => {
            let total;

            // For all collection requests get the total count.
            if ([GET_LIST, GET_MANY, GET_MANY_REFERENCE].includes(type)) {
                // Use the length of the data array as a fallback.
                total = response.data.length;
                if (pageFinish > total) {
                    pageFinish = total;
                }
            }

            switch (type) {
                case GET_MANY: {
                    console.log("Getting Many");
                    // console.log(idxs)
                    if (idxs.length > 0) {
                        let data = idxs.map(idx => {
                            let arr = response.data.filter(obj => obj.userId == idx);
                            if (arr.length > 0) {
                                return arr[0];
                            }
                        }).slice(pageStart, pageFinish);

                        // if (url.includes("appointments/search")){
                        // 	data.map(item => {
                        // 		API.getProfiles({userId: item.clientUserId}).then((profile) => {
                        // 			item.userName = `${profile[0].firstName} ${profile[0].lastName}`;
                        // 			item.userPhoneNumber = profile[0].phoneNumber;
                        // 			item.userEmail = profile[0].emailAddress;
                        // 		});
                        // 		API.getProfiles({userId: item.vetUserId}).then((profile) => {
                        // 			item.vetName = `Dr. ${profile[0].lastName}`;
                        // 			item.vetPhoneNumber = profile[0].phoneNumber;
                        // 			item.vetEmail = profile[0].emailAddress;
                        // 		});
                        // 	})
                        // };
                        return {
                            data: data,
                            total: total,
                        };
                    } else {
                        return {
                            data: response.data.slice(pageStart, pageFinish),
                            total: total
                        };
                    }
                }
                case GET_LIST: {
                    const items = response.data.sort((a, b) => {
                        if (sortOrder !== "ASC") {
                            return a[sortField] - b[sortField];
                        } else {
                            return b[sortField] - a[sortField];
                        }
                    }).slice(pageStart, pageFinish);
                    // console.log(items)

                    // if (url.includes("appointments/search")){
                    // 	items.map(item => {
                    // 		// console.log(new Date(item.scheduledDate).getTimezoneOffset())
                    // 		API.getProfiles({userId: item.clientUserId}).then((profile) => {
                    // 			item.userName = `${profile[0].firstName} ${profile[0].lastName}`;
                    // 			item.userPhoneNumber = profile[0].phoneNumber;
                    // 			item.userEmail = profile[0].emailAddress;
                    // 		});
                    // 		API.getProfiles({userId: item.vetUserId}).then((profile) => {
                    // 			item.vetName = `Dr. ${profile[0].lastName}`;
                    // 			item.vetPhoneNumber = profile[0].phoneNumber;
                    // 			item.vetEmail = profile[0].emailAddress;
                    // 		});
                    // 	})
                    // };
                    // console.log(items)

                    return {
                        data: items,
                        total: total,
                    };
                }

                case GET_MANY_REFERENCE: {
                    const items = response.data.sort((a, b) => {
                        if (sortOrder !== "ASC") {
                            return a[sortField] - b[sortField];
                        } else {
                            return b[sortField] - a[sortField];
                        }
                    }).slice(pageStart, pageFinish);
                    // console.log(items)

                    // if (url.includes("appointments/search")){
                    // 	items.map(item => {
                    // 		// console.log(new Date(item.scheduledDate).getTimezoneOffset())
                    // 		API.getProfiles({userId: item.clientUserId}).then((profile) => {
                    // 			item.userName = `${profile[0].firstName} ${profile[0].lastName}`;
                    // 			item.userPhoneNumber = profile[0].phoneNumber;
                    // 			item.userEmail = profile[0].emailAddress;
                    // 		});
                    // 		API.getProfiles({userId: item.vetUserId}).then((profile) => {
                    // 			item.vetName = `Dr. ${profile[0].lastName}`;
                    // 			item.vetPhoneNumber = profile[0].phoneNumber;
                    // 			item.vetEmail = profile[0].emailAddress;
                    // 		});
                    // 	})
                    // };
                    // console.log(items)

                    return {
                        data: items,
                        total: total,
                    };
                }

                case GET_ONE: {
                    const respData = response.data;
                    const id = respData.id;
                    const attributes = respData;

                    return {
                        data: {
                            id, ...attributes,
                        },
                    };
                }

                case CREATE: {
                    const {id, attributes} = response.data;

                    return {
                        data: {
                            id, ...attributes,
                        },
                    };
                }

                case UPDATE: {
                    const {id, attributes} = response.data;

                    return {
                        data: {
                            id, ...attributes,
                        },
                    };
                }

                case DELETE: {
                    return {
                        data: {id: params.id},
                    };
                }

                default:
                    console.log(`Unsupported Data Provider request type ${type}`);
            }
        });
};
